// fieldPredicate.js
// Pure evaluation for capture-tab-schema.json's shared fieldPredicate shape
// ({field, op, values, negate}), used by both statTile (counts matching
// items) and computedBadge (shows/hides a per-item badge) -- one predicate
// concept, two consumers, evaluated by one function so they can't drift.
export function evaluateFieldPredicate(predicate, itemData) {
  const value = itemData ? itemData[predicate.field] : undefined;
  let matches;
  if (predicate.op === "in") {
    // Coerced to string so a boolean-backed field (e.g. a checkbox's
    // true/false) can be matched with values: ["true"], same as any
    // string-backed field (e.g. a select's "confirmed") -- safe for
    // existing string values since String("x") === "x".
    matches = predicate.values.includes(String(value));
  } else if (predicate.op === "emptyOrIncludes") {
    matches = !value || predicate.values.some(function (v) { return String(value).includes(v); });
  } else {
    matches = false;
  }
  return predicate.negate ? !matches : matches;
}
